export const RECEIVED_ARTICLES = 'RECEIVED_ARTICLES';
export const RECEIVED_CATEGORIES = 'RECEIVED_CATEGORIES';
export const RECEIVED_SLIDERS = 'RECEIVED_SLIDERS';
export const RECEIVED_DEVICE = 'RECEIVED_DEVICE';
export const RECEIVED_DEVICE_CONFIG = 'RECEIVED_DEVICE_CONFIG';
export const RECEIVED_EVENTS = 'RECEIVED_EVENTS';
export const RECEIVED_MACHINES = 'RECEIVED_MACHINES';
export const RECEIVED_GALLERIES = 'RECEIVED_GALLERIES';
export const RECEIVED_GALLERY = 'RECEIVED_GALLERY';
